// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hlF8","buttons":"styles_buttons__1-Xk3"};